<div class="container-fluid footer-bottom-administation-page">
  <mat-card class="ddc-card-with-title">
    <mat-card-title>
      <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.administrationMaintenance"></span>
    </mat-card-title>

    <mat-card-content>
      <div ddcLabel labelKey="appli.accueil.administrationEmail.carte.administrationMaintenance.content"
           class="ddc-appli-description">
      </div>
      <div class="row">
        <mat-form-field floatLabel="always" class="col-md-8 col-sm-12">
          <textarea type="text" [rows]="10" matInput [(ngModel)]="maintenanceMessage">
          </textarea>
        </mat-form-field>
      </div>

      <div ddcLabel labelKey="appli.accueil.administrationEmail.carte.administrationMaintenance.activate"
           class="ddc-appli-description">
      </div>
      <div class="row">
        <div floatLabel="always" class="col-sm-6 col-md-3">
          <mat-checkbox [(ngModel)]="isMaintenanceActive">
            Activée
          </mat-checkbox>
        </div>
      </div>

      <ng-container>
        <div class="row">
          <div class="col-md-8 col-sm-12 ddc-button-mofification">
            <button mat-raised-button class="ddc-button-primary ddc-button-right"
                    [disabled]="isLoading"
                    (click)="updateMaintenance()">
              Enregistrer
            </button>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>

    <mat-card class="ddc-card-with-title">
        <mat-card-title>
            <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure"></span>
        </mat-card-title>

        <mat-card-content>
            <div *ngIf="structuresSync; else noStructureBlock" class="row ddc-margin-bottom ddc-margin-auto">
                <div class="col-md-2">
                    <div class="ddc-read-only-data-container ddc-margin-bottom">
                        <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.etat"></span>&nbsp;
                        <span class="ddc-value">{{BATCH_SYNCHRONISATION_ETAT[structuresSync.etat]}}</span>
                    </div>
                </div>
                <div class="col-md-3">
                  <div class="ddc-read-only-data-container ddc-margin-bottom">
                    <span ddcLabel labelKey="bdd.logError.numeroAdherent"></span>&nbsp;
                    <span class="ddc-value">{{structuresSync.adherent?.numero}}</span>
                  </div>
                </div>
                <div class="col-md-7 row">
                    <div class="col-md-2 ddc-read-only-data-container ddc-margin-bottom">
                        <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.lastExecution"></span>&nbsp;
                    </div>
                    <div class="col-md-4">
                        <div class="ddc-read-only-data-container ddc-margin-bottom">
                            <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.dateDebut"></span>&nbsp;
                            <span class="ddc-value">{{convertToHumanDate(structuresSync.dateDebut, true, true)}}</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="ddc-read-only-data-container ddc-margin-bottom">
                            <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.dateFin"></span>&nbsp;
                            <span class="ddc-value">{{convertToHumanDate(structuresSync.dateFin, true, true)}}</span>
                        </div>
                    </div>
                </div>

            </div>
            <ng-template #noStructureBlock>
                <div class="ddc-warning-message ddc-margin-bottom">
                    <span class="material-icons">info</span>
                    <span>Aucun résultat de synchronisation</span>
                </div>
            </ng-template>
            <ng-container>
                <div class="row ddc-margin-auto">
                    <div class="col-md-8 col-sm-12">
                        <button mat-raised-button class="ddc-button-primary ddc-button-left"
                                [disabled]="isLoading"
                                (click)="syncStructures()">
                            Synchroniser les structures
                        </button>
                    </div>
                </div>
            </ng-container>
        </mat-card-content>
    </mat-card>
    <mat-card class="ddc-card-with-title">
        <mat-card-title>
            <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationAdherent"></span>
        </mat-card-title>

        <mat-card-content>
            <div *ngIf="adherentsSync; else noAdherentBlock" class="row ddc-margin-bottom ddc-margin-auto">
              <div class="col-md-2">
                  <div class="ddc-read-only-data-container ddc-margin-bottom">
                      <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.etat"></span>&nbsp;
                      <span class="ddc-value">{{BATCH_SYNCHRONISATION_ETAT[adherentsSync.etat]}}</span>
                  </div>
              </div>
              <div class="col-md-3">
                <div class="ddc-read-only-data-container ddc-margin-bottom">
                  <span ddcLabel labelKey="bdd.logError.numeroAdherent"></span>&nbsp;
                  <span class="ddc-value">{{adherentsSync.adherent?.numero}}</span>
                </div>
              </div>
              <div class="col-md-7 row">
                <div class="col-md-2 ddc-read-only-data-container ddc-margin-bottom">
                  <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.lastExecution"></span>&nbsp;
                </div>
                <div class="col-md-4">
                    <div class="ddc-read-only-data-container ddc-margin-bottom">
                        <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.dateDebut"></span>&nbsp;
                        <span class="ddc-value">{{convertToHumanDate(adherentsSync.dateDebut, true, true)}}</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ddc-read-only-data-container ddc-margin-bottom">
                        <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.dateFin"></span>&nbsp;
                        <span class="ddc-value">{{convertToHumanDate(adherentsSync.dateFin, true, true)}}</span>
                    </div>
                </div>
              </div>
            </div>
            <ng-template #noAdherentBlock>
                <div class="ddc-warning-message ddc-margin-bottom">
                    <span class="material-icons">info</span>
                    <span>Aucun résultat de synchronisation</span>
                </div>
            </ng-template>
            <ng-container>
                <div class="row ddc-margin-auto">
                    <div class="col-md-8 col-sm-12">
                        <button mat-raised-button class="ddc-button-primary ddc-button-left"
                                [disabled]="isLoading"
                                (click)="syncAdherents()">
                            Synchroniser les adhérents
                        </button>
                    </div>
                </div>
            </ng-container>
        </mat-card-content>
    </mat-card>
    <mat-card class="ddc-card-with-title">
        <mat-card-title>
            <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationMail"></span>
        </mat-card-title>

        <mat-card-content>
            <div *ngIf="notificationMailsSync; else noMailBlock" class="row ddc-margin-bottom ddc-margin-auto">
              <div class="col-md-2">
                  <div class="ddc-read-only-data-container ddc-margin-bottom">
                      <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.etat"></span>&nbsp;
                      <span class="ddc-value">{{BATCH_SYNCHRONISATION_ETAT[notificationMailsSync.etat]}}</span>
                  </div>
              </div>
              <div class="col-md-3">
                <div class="ddc-read-only-data-container ddc-margin-bottom">
                  <span ddcLabel labelKey="bdd.logError.numeroAdherent"></span>&nbsp;
                  <span class="ddc-value">{{notificationMailsSync.adherent?.numero}}</span>
                </div>
              </div>
              <div class="col-md-7 row">
                <div class="col-md-2 ddc-read-only-data-container ddc-margin-bottom">
                  <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.lastExecution"></span>&nbsp;
                </div>
                <div class="col-md-4">
                    <div class="ddc-read-only-data-container ddc-margin-bottom">
                        <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.dateDebut"></span>&nbsp;
                        <span class="ddc-value">{{convertToHumanDate(notificationMailsSync.dateDebut, true, true)}}</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ddc-read-only-data-container ddc-margin-bottom">
                        <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.synchronisationStructure.dateFin"></span>&nbsp;
                        <span class="ddc-value">{{convertToHumanDate(notificationMailsSync.dateFin, true, true)}}</span>
                    </div>
                </div>
              </div>
            </div>
            <ng-template #noMailBlock>
                <div class="ddc-warning-message ddc-margin-bottom">
                    <span class="material-icons">info</span>
                    <span>Aucun résultat de synchronisation</span>
                </div>
            </ng-template>
            <ng-container>
                <div class="row ddc-margin-auto">
                    <div class="col-md-8 col-sm-12">
                        <button mat-raised-button class="ddc-button-primary ddc-button-left"
                                [disabled]="isLoading"
                                (click)="sendNotifications()">
                            Envoyer les mails de notification en attente
                        </button>
                    </div>
                </div>
            </ng-container>
        </mat-card-content>
    </mat-card>
    <mat-card class="ddc-card-with-title">
        <mat-card-title>
            <span ddcLabel labelKey="appli.accueil.administrationEmail.carte.logErrors"></span>
        </mat-card-title>
      <form [formGroup]="filterForm" (ngSubmit)="searchLogErrors()" class="row">
        <mat-form-field floatLabel="always" class="col-sm-5 col-md-3">
            <mat-label ddcLabel labelKey="appli.accueil.administrationEmail.carte.logErrors.search.startDate"></mat-label>
            <input matInput [matDatepicker]="dateDebutDatepicker" formControlName="dateDebut">
            <mat-datepicker-toggle matSuffix [for]="dateDebutDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #dateDebutDatepicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field floatLabel="always" class="col-sm-5 col-md-3">
            <mat-label ddcLabel labelKey="appli.accueil.administrationEmail.carte.logErrors.search.endDate"></mat-label>
            <input matInput [matDatepicker]="dateFinDatepicker" formControlName="dateFin">
            <mat-datepicker-toggle matSuffix [for]="dateFinDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #dateFinDatepicker></mat-datepicker>
        </mat-form-field>
        <button mat-raised-button class="ddc-button-primary ddc-button-left col-sm-1 col-md-1" type="submit">
          Chercher
        </button>
      </form>
        <mat-card-content>
            <div class="ddc-table-div-container-noscroll">
                <ng-container
                        *ngIf="logErrors?.length > 0; else noResultsBlock">
                    <table mat-table matSort
                           [dataSource]="logErrors"
                           (matSortChange)="onSort($event)">

                      <ng-container matColumnDef="expand">
                        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                        <td mat-cell *matCellDef="let element">
                          <button
                            mat-icon-button
                            aria-label="expand row"
                            (click)="toggle(element); $event.stopPropagation()"
                            class="example-toggle-button"
                            [class.example-toggle-button-expanded]="isExpanded(element)">
                            <mat-icon>keyboard_arrow_down</mat-icon>
                          </button>
                        </td>
                      </ng-container>

                        <ng-container matColumnDef="categorie">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                <span ddcLabel labelKey="bdd.logError.categorie"></span>
                            </th>
                            <td mat-cell *matCellDef="let logError" >
                                {{logError.categorie}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="dateCreation">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                <span ddcLabel labelKey="bdd.logError.dateCreation"></span>
                            </th>
                            <td mat-cell *matCellDef="let logError" >
                                {{convertToHumanDate(logError.dateCreation, true, false)}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="message">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                <span ddcLabel labelKey="bdd.logError.message"></span>
                            </th>
                            <td mat-cell *matCellDef="let logError">
                              @if (isExpanded(logError) || logError.message?.length <= 150) {
                                {{ logError.message }}
                              } @else {
                                {{ logError.message | slice:0:150 }}...
                              }
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="adherent">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                <span ddcLabel labelKey="bdd.logError.numeroAdherent"></span>
                            </th>
                            <td mat-cell *matCellDef="let logError">
                                {{logError.adherent?.numero}}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="logErrorDisplayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: logErrorDisplayedColumns;"
                            (click)="toggle(row)"></tr>
                    </table>
                </ng-container>
                <ng-template #noResultsBlock>
                    <div class="ddc-warning-message">
                        <span class="material-icons">info</span>
                        <span>Aucune erreur remontée</span>
                    </div>
                </ng-template>
            </div>
        </mat-card-content>

    </mat-card>
</div>
